export default "__VITE_ASSET__0Yt$n2Ky__"